import { SaveFile } from '@gkn-ili/views/dist/mocks/order-service';
export const FixtureKnuckle: SaveFile = {
  order: {
    key: 'Order.0001',
    articleCode: '60P5510-03N801',
    name: 'Knuckle joint',
    description: 'Assembly and measurement of knuckle joint',
  },
  routingItems: [
    {
      key: 'RoutingItem.0001',
      belongsToKey: 'Order.0001',
      belongsToPosition: 0,
      name: 'Assembly',
      department: '96F',
      type: 'SABO',
      progress: 0,
      status: 'inWork',
    },
  ],
  routingItemSteps: [
    {
      key: 'RoutingItemStep.0001',
      belongsToKey: 'RoutingItem.0001',
      belongsToPosition: 0,
      name: 'Assemble knuckles',
      content: {
        text: ['Assembly of the knuckles and locking using pins'],
      },
      progress: 0,
      status: 'toStart',
      depends: [],
    },
    {
      key: 'RoutingItemStep.0002',
      belongsToKey: 'RoutingItem.0001',
      belongsToPosition: 1,
      name: 'Clearance check',
      content: { text: ['Check and verify the clearances'] },
      status: 'toStart',
      progress: 0,
      depends: ['010'],
    },
  ],
  activityGroups: [
    {
      key: 'ActivityGroup.0001',
      belongsToKey: 'RoutingItemStep.0001',
      belongsToPosition: 0,
      name: 'Join the two knuckles',
      description: 'Assembly of the knuckles and locking using pins',
      content: {
        model: {
          configuration: {
            enhancedViewKey: 'base',
            modifiers: [],
          },
        },
      },
      performed: null,
      checked: null,
    },
    {
      key: 'ActivityGroup.0002',
      belongsToKey: 'RoutingItemStep.0002',
      belongsToPosition: 1,
      name: 'Check the axial play on the pin.',
      content: {
        text: ['Using calipers measure the gap between the knuckles.'],
      },
      performed: null,
      checked: null,
    },
  ],

  activities: [
    {
      key: 'Activity.0001',
      belongsToKey: 'ActivityGroup.0001',
      belongsToPosition: 0,
      genericActivityKey: 'InstallComponent',
      name: 'Assemble components',
      count: 1,
      description: 'Install {{ partNumber }}',
      subjects: [
        { ref: ['Product1', 'knucle 1.1'], showPartNumber: true, offsetPosition: [50, 0, 0] },
        { ref: ['Product1', 'knucle 2.1'] },
      ],
      content: {
        model: {
          configuration: {
            modifiers: [
              { reference: ['Product1', 'collar.1'], visible: false },
              { reference: ['Product1', 'pin.1'], visible: false },
              { reference: ['Product1', 'taper pin.1'], visible: false },
            ],
            enhancedViewKey: 'base',
          },
        },
      },
      customAttributes: {},
    },
    {
      key: 'Activity.0002',
      belongsToKey: 'ActivityGroup.0001',
      belongsToPosition: 1,
      genericActivityKey: 'InstallComponent',
      name: 'Insert main pin',
      count: 1,
      description: 'Install {{ partNumber }}',
      content: {
        model: {
          configuration: {
            modifiers: [
              { reference: ['Product1', 'collar.1'], visible: false },
              { reference: ['Product1', 'taper pin.1'], visible: false },
            ],
            enhancedViewKey: 'base',
          },
        },
      },
      subjects: [{ ref: ['Product1', 'pin.1'] }],
      customAttributes: {},
    },
    {
      key: 'Activity.0003',
      belongsToKey: 'ActivityGroup.0001',
      belongsToPosition: 2,
      genericActivityKey: 'InstallComponent',
      count: 1,
      name: 'Add colar',
      description: 'Install {{ partNumber }}',
      subjects: [{ ref: ['Product1', 'collar.1'] }],
      content: {
        model: {
          configuration: {
            modifiers: [{ reference: ['Product1', 'taper pin.1'], visible: false }],
            enhancedViewKey: 'base',
          },
        },
      },
      customAttributes: {},
    },
    {
      key: 'Activity.0004',
      belongsToKey: 'ActivityGroup.0001',
      belongsToPosition: 3,
      genericActivityKey: 'InstallComponent',
      count: 1,
      name: 'Insert tapered pin',
      description: 'Install {{ partNumber }}',
      subjects: [{ ref: ['Product1', 'taper pin.1'] }],
      content: {
        model: {
          configuration: {
            modifiers: [],
            enhancedViewKey: 'base',
          },
        },
      },
      customAttributes: {},
    },
    {
      key: 'Activity.0005',
      belongsToKey: 'ActivityGroup.0002',
      belongsToPosition: 4,
      genericActivityKey: 'InspectDimension',
      name: 'Axial-Gap',
      description: 'Gap between knuckle 1 and 2',
      content: {
        text: ['Using calipers measure the gap between the knuckles.'],
      },
      count: 1,
      subjects: [],
      customAttributes: {},
    },
    {
      key: 'Activity.0006',
      belongsToKey: 'ActivityGroup.0002',
      belongsToPosition: 5,
      genericActivityKey: 'InspectDimension',
      name: 'Minimum angle',
      description: 'The minimum angle from nominal in degrees',
      content: {
        text: ['Measure the minimum travel angle'],
      },
      count: 1,
      subjects: [],
      customAttributes: {},
    },
    {
      key: 'Activity.0007',
      belongsToKey: 'ActivityGroup.0002',
      belongsToPosition: 5,
      genericActivityKey: 'InspectDimension',
      name: 'Maximum angle',
      description: 'The maximum angle from nominal in degrees',
      content: {
        text: ['Measure the minimum travel angle'],
      },
      count: 1,
      subjects: [],
      customAttributes: {},
    },
  ],
  modelFile: 'knuckle joint assembly_test.3dxml',
};

export default FixtureKnuckle;
